<template>
  <v-col
    v-if="hasAvailableAds"
    :id="`ads-index-${index}`"
    class="pa-0 my-2"
    cols="12"
  >
    <v-row no-gutters v-if="textCarouselItem">
      <p
        :class="{
          'ma-0 pa-0 subtitle-1 font-weight-bold primary--text transparent':
            !textCarouselItem.text_class,
          [textCarouselItem.text_class]: textCarouselItem.text_class,
        }"
      >
        {{ textCarouselItem.text }}
      </p>
    </v-row>
    <v-row
      no-gutters
      v-if="carouselItems && carouselItems.length"
      justify="center"
    >
      <vetalfa-carousel
        @carouselItemClick="confirmClick"
        :items="carouselItems"
        class="my-2"
        :height="carouselItems[0].height"
        :style="`width: ${carouselItems[0].image_width}%`"
        :contain="false"
      ></vetalfa-carousel>
    </v-row>
    <v-row no-gutters v-if="textListItem">
      <p
        :class="{
          'ma-0 pa-0 subtitle-1 font-weight-bold primary--text transparent':
            !textListItem.text_class,
          [textListItem.text_class]: textListItem.text_class,
        }"
      >
        {{ textListItem.text }}
      </p>
    </v-row>
    <v-row
      no-gutters
      v-if="listItems && listItems.length"
      justify="space-between"
    >
      <v-col
        class="pa-0 my-1"
        :class="{
          [item.column_class]: item.column_class,
        }"
        :cols="item.columns"
        v-for="(item, index) of listItems"
        :key="`list-item-${index}`"
      >
        <v-card
          elevation="0"
          class="vetalfa-card-grey-border py-2 pl-2 pr-5"
          @click="confirmClick(item)"
        >
          <v-row no-gutters align="center" justify="center">
            <v-icon
              x-small
              style="position: absolute; top: 40%; right: 8px; translateY(-50%)"
            >
              {{ mdiChevronRight }}
            </v-icon>
            <v-col class="shrink ma-0 pa-0 mr-4" v-if="item.photo">
              <v-img
                :max-width="`${item.image_width}px`"
                :height="`${item.image_width}px`"
                position="center"
                :src="item.photo"
                contain
                style="border-radius: 5px"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      width="2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
            <v-col class="grow ma-0 pa-0">
              <v-row no-gutters>
                <p
                  :class="{
                    'ma-0 pa-0 primary--text subtitle-1': !item.title_class,
                    [item.title_class]: item.title_class,
                  }"
                >
                  {{ item.title }}
                </p>
              </v-row>
              <v-row no-gutters>
                <p
                  :class="{
                    'mt-2 ma-0 pa-0 subtitle-2 grey--text text--darken-2':
                      !item.text_class,
                    [item.text_class]: item.text_class,
                  }"
                >
                  {{ item.text }}
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      persistent
      v-if="dialogModel && dialogItem"
      v-model="dialogModel"
      max-width="350px"
      transition="dialog-bottom-transition"
      content-class="ads-dialog"
      overlay-opacity="0.9"
    >
      <v-card
        elevation="0"
        class="ma-0 px-4 py-10"
        color="primary"
        style="border-radius: 15px"
      >
        <v-img :src="dialogItem.photo" :contain="true" max-height="150px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                width="2"
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <v-row
          class="ma-0 pa-0 px-5"
          :class="{ 'mt-10': !!dialogItem.photo }"
          justify="center"
        >
          <p class="ads-dialog-title">{{ dialogItem.title }}</p>
        </v-row>
        <v-row class="ma-0 pa-0 mt-2 px-2" justify="center">
          <p class="ads-dialog-text">{{ dialogItem.text }}</p>
        </v-row>
        <v-row class="ma-0 pa-0 mt-6 mx-5 px-5" justify="center">
          <v-btn
            @click="confirmClick(dialogItem)"
            color="white"
            class="text-none"
            large
            rounded
          >
            <p class="ma-0 pa-0 primary--text font-weight-bold px-4">
              {{ dialogItem.confirm_button }}
            </p>
          </v-btn>
        </v-row>
      </v-card>
      <v-btn
        v-if="dialogModel"
        @click="closeClick(dialogItem)"
        large
        elevation="0"
        text
        color="white"
        class="text-none ads-dialog-close-button"
      >
        <p class="ma-0 pa-0">
          {{ dialogItem.close_button }}
        </p>
      </v-btn>
    </v-dialog>
  </v-col>
</template>

<style>
.ads-dialog {
  box-shadow: unset !important;
  -webkit-box-shadow: unset !important;
}
.ads-dialog-close-button {
  margin-top: 40px;
}
.ads-dialog-title {
  font-size: 22px;
  line-height: 26px;
  color: white;
  font-weight: bold;
  text-align: center;
}
.ads-dialog-text {
  font-size: 14px;
  line-height: 18px;
  color: white;
  font-weight: normal;
  text-align: center;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mdiChevronRight } from "@mdi/js";
export default {
  methods: {
    ...mapActions("general", [
      "logEvent",
      "openExternalUrl",
      "routePathRedirect",
    ]),
    ...mapActions("preferences", ["postAdsClick", "getAds"]),
    async getAvailableAds() {
      this.carouselItems = [];
      this.listItems = [];
      this.dialogItem = null;
      const ads = await this.getAds({
        location: this.$route.path,
        index: this.index,
        breakpoint: this.$vuetify.breakpoint.name,
      });
      this.requestTime = this._getTimestamp();
      for (let ad of ads) {
        let metadata;
        try {
          metadata = JSON.parse(ad.ads_metadata) || {};
        } catch {
          metadata = {};
        }
        if (ad.ads_type === "dialog") {
          this.dialogItem = ad;
        } else if (ad.ads_type === "carousel") {
          this.carouselItems.push({
            ...ad,
            ...metadata,
            height: metadata.height || 100,
            src: ad.photo,
            web_src: ad.web_photo || null,
            image_width: metadata.image_width || 100,
          });
        } else if (ad.ads_type === "list") {
          this.listItems.push({
            ...ad,
            ...metadata,
            title_class: metadata.title_class || null,
            text_class: metadata.text_class || null,
            columns: metadata.columns || 12,
            column_class: metadata.column_class || null,
            image_width: metadata.image_width || 80,
          });
        } else if (ad.ads_type === "text_carousel") {
          this.textCarouselItem = { ...ad, ...metadata };
        } else if (ad.ads_type === "text_list") {
          this.textListItem = { ...ad, ...metadata };
        }
      }
      if (this.dialogItem) {
        this.dialogModel = true;
      }
      this.$nextTick(() => {
        this.$emit("adsLoaded");
      });
    },
    confirmClick(item) {
      this.postClick(true, item);
    },
    closeClick(item) {
      this.postClick(false, item);
    },
    async postClick(confirm, item) {
      this.postAdsClick({
        confirm,
        requestTime: this.requestTime,
        ads_uid: item.ads_uid,
      });
      if (item.ads_type === "dialog") {
        this.dialogModel = false;
      }
      if (confirm) {
        this.redirectToLink(item);
      }
    },
    redirectToLink(item) {
      if (!item.external_url) {
        this.routePathRedirect({
          path: item.url,
        });
      } else {
        this.openExternalUrl({
          url: item.url,
          inAppBrowser: true,
        });
      }
    },
  },
  props: {
    index: {
      type: String,
      default: 'default',
    },
  },
  mounted() {},
  computed: {
    ...mapGetters("general", ["user"]),
    ...mapGetters("preferences", ["ads"]),
    hasAvailableAds() {
      return (
        this.carouselItems.length ||
        this.listItems.length ||
        this.dialogItem ||
        this.textCarouselItem ||
        this.textListItem
      );
    },
  },
  data() {
    return {
      dialogModel: false,
      dialogItem: null,
      textCarouselItem: null,
      textListItem: null,
      carouselItems: [],
      listItems: [],
      requestTime: null,
      mdiChevronRight,
    };
  },
  created() {
    this.getAvailableAds();
  },
};
</script>
